// extracted by mini-css-extract-plugin
module.exports = {"wysiwyg":"wysiwyg_wysiwyg__v035P"};